import { Component, OnInit, HostListener, ViewChild, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { MatSelect } from '@angular/material/select';
import { MatAccordion } from '@angular/material/expansion';
import _, { constant, upperFirst } from 'lodash';
import { take } from 'rxjs/operators';
import { Global } from 'src/app/global/globalApi';
import { ApiService } from 'src/app/services/api.service';
import { CustomerAccountBusinessLogicService } from 'src/app/services/customer-account-business-logic.service';
import { CustBusService } from 'src/app/services/customer-search-bussiness-logic.service';
import { NewAgentApiService } from 'src/app/services/new-agent-api.service';
import { RootScopeService } from 'src/app/services/root-scope.service';
import * as Constants from './../../../models/Constants';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { CallCustomerAttributes, sAuthModel } from 'src/app/models/customer.model';
import { GenesysCloudService } from 'src/app/services/genesys-cloud.service';
import { AuthMethodService } from 'src/app/services/auth-method.service';
import { OtcService } from 'src/app/services/otc.service';
import { LogService } from 'src/app/services/log.service';
import { AaaSService } from 'src/app/services/aaas.service';
import { ClearIdentityService } from 'src/app/services/clear-identity.service';

export interface IMySelectOption {
  id: number;
  value: string;
  label: string;
}
@Component({
  selector: 'app-authentication',
  templateUrl: './authentication.component.html',
  styleUrls: ['./authentication.component.scss'],

})
export class AuthenticationComponent implements OnInit {
  @Output()
  changeCustomerTypeEmitter: EventEmitter<any> = new EventEmitter();
  @Output()
  goToApprovedExceptionPageEmitter: EventEmitter<any> = new EventEmitter();
  @Output()
  goToCustomerOverviewPageEmitter: EventEmitter<any> = new EventEmitter();
  errorMsg = Constants.CUSTOMER_TYPE_FAILURE_MSG;
  @Output() updateSecurityForAPEX: EventEmitter<any> = new EventEmitter();
  public authEgainConfig: any;
  public eGainConfig = Constants.AuthMenu;
  public fullySecured = Constants.FULLY_SECURED;
  authConfigUserData: any;
  pinChangeErrMsg:any;
  pinChangeEnabled:any;
  remainingAttempt:any;
  //Pin Reset CCR6-566
  // This is a static value. Please remove once feature works on the same.
  langOption: string | undefined;
  lang_method: string[] = ['English', 'French', 'Spanish'];
  // Display the dropdown for Bad Address
  // One time code CCR6-572
  public selectedValue?: IMySelectOption;
  languages: any;
  selectedLanguage: string = '';
  loaderType = Constants.LOADER_TYPE.CARD;
  showLoader: boolean = false;
  showEgainLoader:boolean=false;
  // Below code to be used and to be removed from multiple places once all the dropdowns are made common.

  @ViewChild(MatSelect) select!: MatSelect;
  @ViewChild(MatAccordion) accordion?: MatAccordion;
  OTCMsg: string = "";
  disableOTCPanel: boolean = false;
  clientConfigButCTNot: boolean =false ;
  displayOTCMsg: boolean = false;
  valMsg: any;
  clearVerificationSuccessMessage : string = Constants.CLEAR_VERIFICATION_CONSTANTS.SUCCESS_MSG;
  @HostListener('window:scroll', [])
  /* istanbul ignore next */
  onScroll(): void {
    if (this.select?.panelOpen) {
      this.select.close();
    }
  }
  panelOpenState = false;
  showContent: boolean = true;
  methodInstruction: boolean = true;
  errorMessage: String = ''; infoMessage: String = '';
  indicativeDataApiFailure = Constants.AUTHENTICATION_COMPONENT_ERR_MSG.API_FAILURE_INDICATIVEDATA;
  indicativeDataConfigMiss = Constants.AUTHENTICATION_COMPONENT_ERR_MSG.CONFIG_MISS_INDICATIVEDATA;
  indicativeDataValueMiss = Constants.AUTHENTICATION_COMPONENT_ERR_MSG.VALUE_MISS_INDICATIVEDATA;
  otcValidateSuccessMessage = Constants.OTC_MESSAGES.OTC_VALIDATION_SUCCESS_MESSAGE;
  maxDate = new Date();
  validationSuccessMessage = Constants.indicativeMessages.validationSuccessMessage;
  pinEntrySuccessMessage = Constants.pinEntryMessages.validationSuccessMessage;
  API_FAil_MSG=  Constants.EXTERNAL_API_FAILURE_MSG;
  userDataBlankMsg = Constants.PERSON_DATA_BLANK_MSG;
  preAuthUserAPIFail=false;
  channel = Constants.conversion;
  peaToolTipMsg:string='';
  peaDisabled:boolean=false;
  infoCodes = Constants.INFO_CODES;
  fileName: string = 'authenticationComponent';
   private deSecureCallFeatureEnabled = false;
   private deSecureCallFeatureCacheClientId: string | number | undefined;
   private deSecureCallFeatureCacheAuthCode: string | undefined;
   private deSecureCallFeatureCacheSecurityLevel: string | number | undefined;
   private deSecureCallFeatureCacheActiveCall: boolean | undefined;
  // CCR1-13262 Indicative data Postal address
  postalAddress = Constants.POSTAL_ADDRESS;
  securityLevel = Constants.securityLevels;
  
  constructor(
    public rootScope: RootScopeService,
    public apiService: ApiService,
    public newAgentapiService: NewAgentApiService,
    public cusAccService: CustomerAccountBusinessLogicService,
    public cusSearchService: CustBusService,
    public fb: FormBuilder,
    private http: HttpClient,
    public genesysCloudService: GenesysCloudService,
    public authService: AuthMethodService,
    public otcService: OtcService,
    public logger: LogService,
    public aaaSservice: AaaSService,
    public clearIdentityService: ClearIdentityService
 
  ) {
     //CCR3-9296 to handle outbound call Config desktop indicator 
    if (this.authService.validateLiveConversation()) {
      this.genesysCloudService.getConfigDesktopIndicator();
      this.logger.infoLogs('getConfigDesktopIndicator successfully called for clientId:' + this.rootScope.activeCustTab.clientId,this.fileName);
    }
    this.identifyClientType();
     
  }

  validationFailureErrorMessage = Constants.indicativeMessages.validationFailureMessage;
  dateOfBirth = new FormControl('', [Validators.required]);
  oneTimeCode = new FormControl('', [Validators.required]);
  
  ngOnInit(): void {
    // this.closeAllAccount(); // CCR1-13188
    // this.confirmDesecureAccount(); // CCR1-13188

    //Enable to show Continue Simulation Popup CCR3-12199
  //  this.cusAccService.showSimulationPopup();
    
      if (!this.rootScope.activeCustTab?.authenticationEgainContent?.authenticationConfig) {
        this.getAuthenticationConfig();

      }
     
      this.checkData();
    

    if (this.rootScope?.mulLanData) {
      this.getLanguages(this.rootScope?.mulLanData);
    }
    if (!this.rootScope.activeCustTab?.IS_AAAS_ENABLED) {
      this.cusSearchService.getAuthenticationMethods(this.rootScope.activeCustTab?.clientId, this.rootScope.activeCustTab?.customerType);
      this.rootScope.peaAuthUserDetails.subscribe(
        (res: any) => {
          if(!this.isAuthenticationMethodVisible(this.eGainConfig.PIN_FSBA))
          this.getPreAuthUserData();
        }
      );
    
      /* istanbul ignore next */ 
      this.genesysCloudService.pinEntryAuthProcEmitter.pipe(take(1)).subscribe((res) => {
        if (this.rootScope.activeCustTab.pinEntryApp.success == 'true' &&
          this.rootScope.activeCustTab.authenticateStatus != Constants.FULLY_SECURED && !this.rootScope.activeCustTab.pinEntryApp.securityDowngraded) {
          this.pinEntryAuthUpgarde(res);
        }
        else if (this.rootScope.activeCustTab.pinEntryApp.securityDowngraded) {
          setTimeout(() => {
            this.rootScope.activeCustTab.pinEntryApp.securityDowngraded = false;
          }, 100);
        }
      });
      
      this.rootScope.getPinRestTempPostAddData(this.rootScope.activeCustTab.clientId);
    }

    if (this.isAuthenticationMethodVisible(this.eGainConfig.AIDV))
      this.cusAccService.getClearIdentityVerfication(this.rootScope.activeCustTab);
  }

  
  /**
   * Identifies the type of client and performs the appropriate authentication actions.
   * @author Vamsi
   * - If the active customer tab has `IS_AAAS_ENABLED` set to true, it invokes the `getAaasUserAuthMethod` method from the AAA service.
   * - Otherwise, it checks the security model of the client and determines the authentication flow:
   *   - For clients with a security model of 'sauth', it retrieves pre-authentication user data and delivery methods.
   *   - For other clients, it invokes the default non-SAuth client handling method.
   * 
   * @remarks
   * This method relies on the `rootScope` object to access the active customer tab and its associated properties.
   * It also interacts with the `aaaSservice` and `authService` to perform authentication-related operations.
   */
  identifyClientType() {
    if (this.rootScope.activeCustTab?.IS_AAAS_ENABLED) {
      this.aaaSservice.getAaasUserAuthMethod();
    } else {
      // Check if the client is SAuth or not
      // if(this.rootScope.getSecurityModel(this.rootScope?.activeCustTab?.clientId)?.toLowerCase()=='sauth'){
      switch (this.rootScope.getSecurityModel(this.rootScope?.activeCustTab?.clientId)?.toLowerCase()) {
        case 'sauth': 
          this.rootScope.activeCustTab.isNoPINClient = this.rootScope.getNoPinClientModel(this.rootScope?.activeCustTab?.clientId);
          this.getPreAuthUserData();
          this.authService.getDeliveryMethods();
          break;
        default:
          this.authService.defaultNoNSauthClient();
          break;
      }
  //  }

    

    }

  }

  /**
     * @author HASHID
     * return updating secuirty level in pin entry
     * creating common mehtod for client side and server validation
     * Based on CCR3-6315
     */
  pinEntryAuthUpgarde(res?) {
    let authCode = res ? this.eGainConfig.FTU : this.eGainConfig.PIN;
    this.rootScope.activeCustTab.pinEntryApp.pinValidMsg = true;
    this.rootScope.activeCustTab.genesysAttributes.CS_AUTH_CD = authCode;
    this.rootScope.activeCustTab.authenticationPinEntryData.validationSuccess = true;
    this.rootScope.activeCustTab.authenticateStatus = Constants.FULLY_SECURED;
    this.rootScope.activeCustTab.iconClass = this.rootScope.isLiveCall ? 'green' : 'solid green';
    let model = {
      CS_SECURITY_LEVEL: Constants.securityLevels.SL4, authenticateStatus: Constants.FULLY_SECURED,
      iconClass: this.rootScope.isLiveCall ? 'green' : 'solid green',
      domain: this.goToCustomerOverviewPageEmitter
    }
    // body for genesys updation
    let body: CallCustomerAttributes = {
      attributes: {
        CS_AUTH_CD: authCode,
        CS_SECURITY_LEVEL:Constants.securityLevels.SL4,
        PINV:Constants.PINV_ATTRIBUTES.FULLY_SECURED
      },
    };
    this.apiService.setAccountSecurityDt(model, body);
  }

  /**
  * Handles PIN change availability based on live call status and customer security level.
  * Enables PIN change if fully secured (level 4), otherwise disables and returns an error message.
  * @author Hashid
  */
 pinChangeErrorHandler() {
  let isPinCustomerType = this.authService.CustTypeConfigCheck(this.eGainConfig.PINCNG);
  
  switch (true) {
    case ((!this.rootScope.isLiveCall && !this.rootScope.isLiveChat) || this.rootScope.activeCustTab?.activeChat):
      this.pinChangeEnabled = false;
      this.pinChangeErrMsg = Constants.PEA_MESSAGES.AVAILABLE_DURING_LIVE_INTERACTION;
      break;
    case (!isPinCustomerType):
      this.pinChangeEnabled = false;
      this.pinChangeErrMsg = Constants.AuthMethods.PINCNG + " " + Constants.NOT_CONFIGURED_CUSTTYPE;
      break;
    case this.rootScope.activeCustTab?.IS_AAAS_ENABLED:
      this.aaaSservice.aaasPinCngInfoMsg(this);
      break;
    case (this.identifymodel()?.personStatus == Constants.SAuthStatus.AF):
      this.pinChangeEnabled = false;
      this.pinChangeErrMsg = Constants.AUTH_AF;
      break;
    case (this.identifymodel()?.personStatus == Constants.AuthMenu.FTU):
      this.pinChangeEnabled = false;
      this.pinChangeErrMsg = Constants.AUTH_FTU;
      break;
    case (this.NOFcase()):
      this.pinChangeEnabled = false;
      this.pinChangeErrMsg = Constants.PEA_MESSAGES.NOF;
      break;
     // CCR3-12708 Regression Issue fix. Added a condition to check for "". 
    case (!this.identifymodel()?.voicePinOnFile && this.identifymodel()?.voicePinOnFile !== ''): 
      this.pinChangeEnabled = false;
      this.pinChangeErrMsg = Constants.PEA_MESSAGES.NO_PIN_ON_FILE;
      break;
    case (this.identifymodel()?.voicePinStatus == Constants.SAuthStatus.LOCKED):
      this.pinChangeEnabled = false;
      this.pinChangeErrMsg = Constants.PEA_MESSAGES.PIN_LOCKED;
      break;
      // CCR3-12211 PIN Reset changes
    /*case (this.identifymodel()?.voicePinStatus?.toLowerCase() == 'expired'  && this.identifymodel()?.voicePinResetDate == '' && this.identifymodel()?.voicePinOnFile==false):
      this.pinChangeEnabled = false;
      this.pinChangeErrMsg = Constants.PEA_MESSAGES.PIN_EXPIRED;
      break;*/
    case (this.rootScope?.activeCustTab?.CS_SECURITY_LEVEL != Constants.securityLevels.SL4):
      this.pinChangeEnabled = false;
      this.pinChangeErrMsg = Constants.PEA_MESSAGES.NOT_AVAILABLE_UNSECURED_CALL;
      break;
    
    default:
      this.pinChangeEnabled = true;
      this.pinChangeErrMsg = '';
      break;
  }
   return this.pinChangeErrMsg
  }
  /**
   * Page load time GetAuthenticationConfig for each menu content id and call overView Egain content
   * 
   */
  getAuthenticationConfig() {
    const tab = this.rootScope.activeCustTab;

    if (tab?.clientId && this.rootScope.authMethodConfig.has(tab.clientId)) {
      let data = this.rootScope.authMethodConfig.get(tab.clientId);
      tab.authenticationEgainContent.authenticationConfig = data;
      this.authEgainConfig = data;
      this.getEgainContent(data.find(x => x["securityMethodCode"] == this.eGainConfig.OverView)?.contentId, true);
    }
    else{
    this.showLoader=true;
    this.logger.infoLogs('request body of getAuthenticationConfig Api payload client id:'+this.rootScope.activeCustTab.clientId,this.fileName);
    this.newAgentapiService.getApi(Global.authenticationApis.gethenticationContentList, { clientId: this.rootScope.activeCustTab.clientId }, 'false', true)
      .subscribe({
        next: (res) => {
           /* istanbul ignore next */    
          if (this.newAgentapiService.errorValidation(res)) {
            this.rootScope.activeCustTab.authenticationEgainContent.authenticationConfig = res.data;
            this.authEgainConfig = res.data;
            this.getEgainContent(res.data.find(x => x["securityMethodCode"] == this.eGainConfig.OverView)?.contentId, true);
            this.logger.debugLogs('getAuthenticationContentList api successfully called:' + JSON.stringify(res.data),this.fileName);
          } else {
            this.rootScope.enableAlerts(Constants.ERROR, res.message);
          }
          this.showLoader=false;
        },
        error: (error) => {
          this.logger.errorLogs(JSON.stringify(error),this.fileName);
          this.showLoader=false;
        }
      });
    }
  }
  /**
   * 
   * @param ContentId need to pass in api reques to capurting eGain  Content
   * @param overView to capurting eGain  Content for over view or authenticationEgainContent
   * 
   */
  /* istanbul ignore next */
  getEgainContent(ContentId, overView?) {
    this.showEgainLoader=true;
    this.logger.infoLogs('request body of getEgainContent Api payload Content Id:'+ContentId,this.fileName);
    this.newAgentapiService.postApi(Global.authenticationApis.fetchEgainContent, { contentId: ContentId }, 'false', Constants.apiVersions, true)
      .subscribe({
        next: (res) => {
           /* istanbul ignore next */    
          if (this.newAgentapiService.errorValidation(res)) {
            if (overView) { this.rootScope.activeCustTab.authenticationEgainContent.overViewHtml = JSON.parse(res.data); this.rootScope.activeCustTab.authenticationEgainContent.overViewError = ''; }
            else { this.rootScope.activeCustTab.authenticationEgainContent.authenticationHtml = JSON.parse(res.data); this.rootScope.activeCustTab.authenticationEgainContent.authEgainError = ''; }
          } else {
            this.updateError(overView);
          }
          this.logger.debugLogs('getEgainContent api successfully called for selected AuthMethod:' + res.data,this.fileName);
          this.showEgainLoader=false
        },
        error: (error) => {
          this.updateError(overView);
          this.logger.errorLogs(JSON.stringify(error),this.fileName);
          this.showEgainLoader=false;
        }
      })
  }

  updateError(overView) {
    if (overView) {
      this.rootScope.activeCustTab.authenticationEgainContent.overViewError = Constants.eGainError[301];
      this.rootScope.activeCustTab.authenticationEgainContent.overViewHtml = { name: '', content: '' };

    } else {
      this.rootScope.activeCustTab.authenticationEgainContent.authEgainError = Constants.eGainError[301];
      this.rootScope.activeCustTab.authenticationEgainContent.authenticationHtml = { name: '', content: '' };;
    }
    this.logger.error(Constants.eGainError[301],this.fileName);
  }

  @HostListener('window:resize', []) resize() {
    if (window.innerWidth >= 1200) {
      this.showContent = true;
      this.methodInstruction = true;
    }
  }
  getErrorMessage() {
    if (this.dateOfBirth.hasError('required')) {
      return 'Date of Birth must be in the MM/DD/YYYY format.';
    }

    return this.dateOfBirth.hasError('dateOfBirth')
      ? 'Incorrect Date of Birth'
      : '';
  }

  eGainUpdate(Type) {

    if (!this.rootScope.activeCustTab?.authenticationEgainContent?.authenticationHtml
      || this.rootScope.activeCustTab?.authenticationEgainContent?.authenticationHtml?.content == ''
      || Type != this.rootScope.activeCustTab?.authenticationEgainContent?.authenticationType) {
      this.rootScope.activeCustTab.authenticationEgainContent.authenticationType = Type;
      this.getEgainContent(this.rootScope.activeCustTab.authenticationEgainContent?.authenticationConfig?.find(x => x['securityMethodCode'] == Type)?.contentId);

    }
  }

  /**
   * 
   * @param Type Selected menu securityMethodCode Type in authentication page
   * To maintain same state when user change from one account other account 
   * @returns boolean value 
   */
  menuExpansionType(Type) {
    return (this.rootScope.activeCustTab?.authenticationEgainContent && this.rootScope.activeCustTab.authenticationEgainContent.authenticationType == Type)
  }

  openAccState(type) {
    this.eGainUpdate(type);
    this.rootScope.activeCustTab.authenticationEgainContent.authenticationType = type;
    this.logger.infoLogs("Expaned auth method type:" + type, this.fileName);
    if(type == this.eGainConfig.OTC){
      this.otcService.getOTCConfig();
    }

    if(type == this.eGainConfig.VAL && this.valState() && !this.rootScope.activeCustTab.VALData.isPopupDisplayed){
      this.rootScope.activeCustTab.VALData.isPopupDisplayed = true;
      this.openVALPopup();
    }
  }

  closeAccState(Type) {
    if (this.rootScope.activeCustTab?.authenticationEgainContent?.authenticationType == Type)
      this.rootScope.activeCustTab.authenticationEgainContent.authenticationType = '';
    this.logger.infoLogs("Collapsed auth method type:" + Type, this.fileName);
  }

  changeCustomerType(event: any) {
    this.rootScope.activeCustTab.pinEntryApp.securityDowngraded = true;
    this.changeCustomerTypeEmitter.emit(event);
    this.logger.infoLogs("changeCustomerType event emitted", this.fileName);
  }


  /** This method emits a value when a click event occurs on the Go to Approved Exception Page link, 
   *which is used within the Customer Account component. */
  goToApprovedExceptionPage() {
    let obj: any = {};
    this.goToApprovedExceptionPageEmitter.emit(obj);
    this.logger.infoLogs("goToApprovedExceptionPage event emitted", this.fileName);
  }

  /**
 * Retrieves error messages for the Date of Birth field in the indicativeDataForm.
 * @returns Error message based on the validation status of the Date of Birth control.
 */
  getIndicativeDataDobErrorMessages(element) {
    const dateOfBirthControl = this.cusAccService.indicativeDataForm.get(element?.key);
    if (dateOfBirthControl?.hasError('required')) {
      return 'Date of Birth must be in the MM/DD/YYYY format.';
    }
    else if (dateOfBirthControl?.hasError('matDatepickerMax')) {
      return 'Date of Birth cannot be a future date.';
    }
    return '';
  }


  /**
   * Handles the form submission for the indicative data form.
   * Logs form values if the form is valid; otherwise, logs an error message.
   */
  onSubmit() {
    if (this.cusAccService.indicativeDataForm.valid) {
      const formValue = this.cusAccService.indicativeDataForm.value;
      this.logger.infoLogs('Submit indicativeDataForm to Validate Credential values for Customer Session id:'+this.rootScope.activeCustTab.customerSessionId,this.fileName);

      const keyTitleArray = this.rootScope.activeCustTab.authenticationIndicativeData?.keyTitleMapping;
      const validatePayload = {};
      Object.keys(formValue).forEach(key => {

        const authenticationData = _.find(keyTitleArray, (x) => {
          return x?.key == key;
        });
        const title = authenticationData?.title;
        const value = formValue[key];

        if (title) {
          if (title?.includes('DOB'))
            validatePayload[title] = this.formatDate(value);
          else
            validatePayload[title] = value;
        }

       

      });
      if (validatePayload) {
        this.validateIndicativeData(validatePayload);
      }

    } else {
      this.logger.errorLogs('Form is not valid. Please correct errors.',this.fileName);
    }
  }
  /**
   * @author Vamsi krishna
   * return updating secuirty level 
   * creating common mehtod for client side and server validation
   * Based on CCR3-4520
   */
  upgradeSecuirtyLevelAuthMethod() {
    this.rootScope.activeCustTab.pinEntryApp.indValidMsg = true;
    this.rootScope.activeCustTab.pinEntryApp.success = null;
    this.rootScope.activeCustTab.genesysAttributes.CS_AUTH_CD = Constants.AuthMethods['IND-DATA'];
    this.rootScope.logMessage('updating security level for IND_DATA:' ,this.fileName);
    this.rootScope.activeCustTab.authenticationIndicativeData.validationSuccess = true;
    if (this.rootScope.activeCustTab.authenticationIndicativeData.validationSuccess) {
      // model for active tab updation
      // Added "this.rootScope.isLiveCall ? 'green' : 'fa-solid green'" codition to show different icon for chat scenario for US CCR3-6018 -->
      let model = {
        CS_SECURITY_LEVEL: Constants.securityLevels.SL4, authenticateStatus: Constants.FULLY_SECURED,
        iconClass: this.rootScope.isLiveCall ? 'green' : 'solid green', CP_INDICATIVE_DATA_SECURED: true,
        domain: this.goToCustomerOverviewPageEmitter
      }
      // body for genesys updation
      let body: CallCustomerAttributes = {
        attributes: {
          CP_INDICATIVE_DATA_SECURED: true,
          CS_AUTH_CD: Constants.AuthCode['IND-DATA']
        },
      };
      this.rootScope.activeCustTab.genesysAttributes.CP_INDICATIVE_DATA_SECURED = true;
      this.rootScope.activeCustTab.iconClass = this.rootScope.isLiveCall ? 'green' : 'solid green';
      // method for updating local & genesys attribute
      this.apiService.setAccountSecurityDt(model, body);
    }
  }

  /**
 * @Author Arun Jaiswal
 * @param validatePayload 
 * Mehtod used  for validation API . This API is used to validate 
 * Indicative data credentionals on Authentication Tab.
 */
  /* istanbul ignore next */
  validateIndicativeData(validatePayload) {
    if (validatePayload && !this.rootScope.checkBlankObj(validatePayload)) {
      this.upgradeSecuirtyLevelAuthMethod();
      this.logger.infoLogs('validateIndicativeData successfully called for customer account',this.fileName);
    }
    else {
      this.rootScope.activeCustTab.authenticationIndicativeData.validationFailure = false;
      this.rootScope.activeCustTab.authenticationIndicativeData.validationSuccess = false;
      this.validateIndicativeDataObs(validatePayload).subscribe({
        next: (res) => {
          if (res && res?.data?.length > 0 && res?.data?.includes('Success')) {
            this.logger.debugLogs("validateIndicativeData api successfully Executed for the customersession:"+this.rootScope.activeCustTab.customerSessionId,this.fileName);
            this.upgradeSecuirtyLevelAuthMethod();
            //this.goToCusOveriew();
          }
          else {
            this.logger.debugLogs("validateIndicativeData api failed",this.fileName);
            this.rootScope.activeCustTab.authenticationContents.authenticationConfigMiss = true;
            this.rootScope.activeCustTab.authenticationIndicativeData.validationFailure = true;
            this.rootScope.setAuthattempt({ "authMethod": Constants.AuthCode['IND-DATA'], "result": "FAIL" });//CCR3-6188
            this.genesysCloudService.updateTelephonyEventData(this.rootScope.genesysCallObj, Constants.AuthCode['IND-DATA'], "FAIL");
          }
        },
        error: (error) => {
          this.rootScope.activeCustTab.authenticationIndicativeData.validationFailure = true;
          this.logger.errorLogs(JSON.stringify(error), this.fileName);
          this.rootScope.setAuthattempt({ "authMethod": Constants.AuthCode['IND-DATA'], "result": "FAIL" });//CCR3-6188
          this.genesysCloudService.updateTelephonyEventData(this.rootScope.genesysCallObj, Constants.AuthCode['IND-DATA'], "FAIL");
        }
      })
    }
  }

  /**
   * 
   * @param validatePayload 
   * @returns obserable to be subscribed for validation API . This API is used to validate 
   * Indicative data credentionals on Authentication Tab.
   */
  validateIndicativeDataObs(validatePayload): Observable<any> {
    return this.http.post(Global.domainUrl + Global.authenticationApis.validateIndicativeData, validatePayload, {
      headers: this.rootScope.getCustAccHeaders(Constants.apiVersions, this.rootScope.activeCustTab.customerSessionId),

    });
  }

  /**
   * Method to trigger emmitter of customer-account component to go to customer over view Page. 
   */
  goToCusOveriew() {
    let obj: any;
    this.goToCustomerOverviewPageEmitter.emit(obj);
  }

  /**
   * @author Arun 
   * @param date 
   * @returns date in MMM-DD-YYYY format . Used to convert date in specific format as per backend API for validation
   */
  formatDate(date: string): string {
    // Convert string to Date object
    const formattedDate = new Date(date);
    // Format the date using toLocaleDateString method
    const month = formattedDate.toLocaleString('en-us', { month: 'short' });
    const day = formattedDate.getDate()?.toString()?.padStart(2, '0');
    const year = formattedDate.getFullYear();
    // Format the date string as "Oct-10-1978"
    return `${month}-${day}-${year}`;
  }


  /**
   * Resets enabled form controls to their initial values on form cancellation.
   */
  onCancelIndicativeData() {
    // Iterate through form controls
    this.rootScope.activeCustTab.authenticationIndicativeData.validationFailure = false;
    this.rootScope.activeCustTab.authenticationIndicativeData['indicativeDataAPIConfigMiss'] = false;
    this.rootScope.activeCustTab.authenticationIndicativeData['indicativeDataValueMiss'] = false;
    this.rootScope.activeCustTab.authenticationIndicativeData['indicativeDataAPIFailure'] = false;

    this.resetIndicativeDataCreds();
    this.logger.infoLogs('onCancelIndicativeData successfully called for customerSessionId:'+this.rootScope.activeCustTab?.customerSessionId,this.fileName);
  }

  resetIndicativeDataCreds() {
    Object.keys(this.cusAccService.indicativeDataForm.controls).forEach(key => {
      const control = this.cusAccService.indicativeDataForm.get(key);
      // Check if the control is enabled
      if (control?.enabled) {
        control.reset();  // Reset only enabled controls
        control.markAsUntouched();
        control.markAsPristine();

      }
    });
    this.logger.infoLogs('resetIndicativeDataCreds successfully called for customerSessionId:'+this.rootScope.activeCustTab?.customerSessionId,this.fileName);
  }

   
  isPeaVisible(securityCode){
    const isPeaExist = this.rootScope.authMethodConfig?.get(this.rootScope.activeCustTab?.clientId)?.find(x=>x?.securityMethodCode==securityCode);
   
    if (isPeaExist) {
      return true;
    }
    else {
      return false;
    }
  }



  isAuthenticationMethodVisible(securityCode) {
    const selectedAuthenticationContent = this.rootScope.activeCustTab.authenticationContents?.selectedAuthenticationContent;

    const authenticationData = _.find(selectedAuthenticationContent, (x) => {
      return x?.securityMethodCode == securityCode;
    });
   

    /** Here if authenticationData is true means securityCode is configured for selectd client and 
     * Customer Type too
     * story no - CCR1-7262
    */

    /***For OTC */
    if(securityCode == Constants.AuthCode.OTC && (this.identifymodel().SAuthStatus == false&&!this.rootScope.activeCustTab?.IS_AAAS_ENABLED)){
      return false;
    }

    /** VAL CCR1-8055 ***/
    if(securityCode == Constants.AuthCode.VAL){ 
      if(this.authService.CustTypeConfigValidation(securityCode)){
        let tabData = this.rootScope.activeCustTab;
        if((tabData.CS_SECURITY_LEVEL == Constants.securityLevels.SL4) && (tabData.genesysAttributes.CS_AUTH_CD == Constants.AuthCode['IND-DATA']) && this.rootScope.activeCustTab.activeCall){
          return false;
        }
        return true;
      }
       else{
        return false;
        }
      }
      
     

    
/* istanbul ignore next */    
    if(securityCode == Constants.AuthCode.OTC && this.isPeaVisible(securityCode )){
      if(!this.authService.CustTypeConfigValidation(securityCode)){
        this.clientConfigButCTNot = true;
        return true;
        // if(this.rootScope.activeCustTab.activeCall)
        //   return true;
        // else{
        //   return false;
        // }
      }
      else{
        this.clientConfigButCTNot = false;
        if(this.rootScope.activeCustTab.activeChat && this.rootScope.activeCustTab?.CS_SECURITY_LEVEL != Constants.securityLevels.SL4){
          return false;
        }
      }
    }



    if (authenticationData) {
      return true;
    }
    else {
      return false;
    }
  }


  tryAgainAuthenticationAPI() {
    this.cusSearchService.getAuthenticationMethods(this.rootScope.activeCustTab?.clientId, this.rootScope.activeCustTab.customerType);
    this.logger.infoLogs('tryAgainAuthenticationAPI successfully called for customerSessionId:'+this.rootScope.activeCustTab?.customerSessionId,this.fileName); 
  }

  /**
   * Checks if there are any indicative data errors and sets the appropriate error message.
   * @returns {boolean} True if there are indicative data errors, false otherwise.
   */
  showIndicativeDataErr(): boolean {
    if (this.rootScope.activeCustTab.authenticationIndicativeData.indicativeDataAPIConfigMiss) {
      this.errorMessage = this.indicativeDataConfigMiss;
      return true;
    }

    else if (this.rootScope.activeCustTab.authenticationIndicativeData.indicativeDataValueMiss) {
      this.errorMessage = this.indicativeDataValueMiss;
      return true;
    }

    else if (this.rootScope.activeCustTab.authenticationIndicativeData.indicativeDataAPIFailure) {
      this.errorMessage = this.indicativeDataApiFailure;
      return true;
    }

    else {
      this.errorMessage = '';
      return false;
    }
  }
  /**
   * @author Vamsi
   * the validate button when user choose indicative method in authentication process
   * @returns true or false for enable or disable the button
   */
  indicativeValidation() {
    // CCR1-13262 - To check if postal address is present then only make the checkbox mandatory and validate the value of checkbox for indicative data validation.
    return ((!this.rootScope.activeCustTab.activeChat && !this.rootScope.activeCustTab.activeCall) || !this.cusAccService.indicativeDataForm.valid || (this.cusAccService.indicativeDataForm.get('additionalCheckboxKey')?.value !== true) || ((this.cusAccService.indicativeDataForm.get('additionalAddressCheckboxKey') && this.cusAccService.indicativeDataForm.get('additionalAddressCheckboxKey')?.value !== true)) || (this.rootScope.activeCustTab.authenticationIndicativeData.indicativeDataValueMiss))
  }

  /**
 * @author Vamsi
 * Research account indicative methods need to disaply info message 
 * @returns true or false for show or hide info message 
 */
  infoWarning(code?) {
   if (this.rootScope.activeCustTab?.channel == Constants.conversion.research || !(this.rootScope.activeCustTab?.activeCall || (code == this.eGainConfig.IND_DATA && this.rootScope.activeCustTab?.activeChat))) {
      this.infoMessage = Constants.AUTH_RESEARCH_ERR;
      return true;
    }   
    else if (code && !this.authService.CustTypeConfigCheck(code)) {
      this.infoMessage = Constants.AuthMethods[code] + " " + Constants.NOT_CONFIGURED_CUSTTYPE; 
      return true;
    }
   else if ((code != Constants.AuthMenu.PIN_REM_FSBA && code != Constants.AuthMenu.PINRESET) && ((this.rootScope.activeCustTab?.activeCall && this.rootScope.activeCustTab?.CS_SECURITY_LEVEL == Constants.securityLevels.SL4) || (this.rootScope.activeCustTab?.activeChat && this.rootScope.activeCustTab?.CS_SECURITY_LEVEL == Constants.securityLevels.SL4))) {
     this.infoMessage = Constants.AUTH_IND_FULLY_SECURED;
     return true;
   }
    else if (code == Constants.AuthMenu.PINRESET&& this.rootScope.activeCustTab?.IS_AAAS_ENABLED) {
      return this.aaaSservice.aaasPinResetInfoMsg(this);
    }
    else if (code == Constants.AuthMenu.OTC&& this.rootScope.activeCustTab?.IS_AAAS_ENABLED) {
      return this.aaaSservice.aaasOTCInfoMsg(this);
    }
    else if (this.identifymodel()?.SAuthStatus && this.identifymodel()?.personStatus == Constants.SAuthStatus.AF) {
      this.infoMessage = Constants.AUTH_AF; return true;
    }
   
    else if (this.identifymodel()?.SAuthStatus && this.identifymodel()?.personStatus == Constants.AuthMenu.FTU) {
      this.infoMessage = Constants.AUTH_FTU; return false;
    }
    else if (code != this.eGainConfig.IND_DATA&&this.NOFcase()){
      this.infoMessage = Constants.PEA_MESSAGES.NOF;
      return true;
    }
    
    else if(code == Constants.AuthMenu.OTC && this.identifymodel().OTC == false){
    //  if (this.identifymodel()?.personStatus == Constants.SAuthStatus.ALLOW)
    //    this.infoMessage = Constants.AUTH_FTU;
    //  else
       this.infoMessage = Constants.OTC_MESSAGES.NO_OTC_ON_FILE;
     return true;
    }
    // else if (this.identifymodel()?.SAuthStatus && this.identifymodel()?.personStatus == Constants.SAuthStatus.ALLOW && code==Constants.AuthMenu.PINRESET ) {
    //   this.infoMessage = Constants.AUTH_FTU; 
    //   return true;
    // }

    else {
      this.infoMessage = ''; return false;
    }
  }
  /**
   * @author VamsiKrishna
   * @returns true/false 
   * to handle No pin on file / no exiting account 
   */
  NOFcase() {
    return (this.identifymodel().preAuthUserAPIFail || this.identifymodel().personStatus == Constants.SAuthStatus.NOF);
  }
  /**
   * @author Jaya
   * CCR3-10352 to handle  PersonStatus = NOF and userID that is blank 
   */
  invalidCustomer() {
    return (this.identifymodel().personStatus == Constants.SAuthStatus.NOF && !this.identifymodel().userId);
  }

  /**
    * checkData() - caching auth config  api value in service
    * in first time load hitting api in else section 
    * @author Amarjeet
    */
    /* istanbul ignore next */  
  checkData() {
    if (this.rootScope.authConfigDataMap?.[this.rootScope.activeCustTab.clientId])
      this.rootScope.authConfigValue = this.rootScope.authConfigDataMap[this.rootScope.activeCustTab.clientId];
    else
      this.getAuthConfig();
    // if (this.rootScope.authConfigUserDataMap?.[this.rootScope.activeCustTab.customerSessionId])
    //   this.authConfigUserData = this.rootScope.authConfigUserDataMap[this.rootScope.activeCustTab.customerSessionId];
    // else
    //   this.getPreAuthUserData();
    this.logger.infoLogs('getAuthConfig API successfully called for customerSession:' + this.rootScope.activeCustTab.customerSessionId, this.fileName);
  }


  /**
  * getAuthConfig() - calling auth config  api and holding in service level
  * @author Amarjeet
  */
  getAuthConfig() {
    this.apiService.getPreAuthConfig(this.rootScope.activeCustTab.clientId).subscribe({
      next: (data: any) => {
          /* istanbul ignore next */
          if(data?.data){
        this.rootScope.authConfigValue = data?.data;
        this.rootScope.authConfigDataMap[this.rootScope.activeCustTab.clientId] = data?.data;
        this.logger.debugLogs("getAuthConfig successfully called response:" + JSON.stringify(data?.data), this.fileName);
      
      }},
      error: (error) => {
        /* istanbul ignore next */
        this.logger.errorLogs(JSON.stringify(error), this.fileName);
      },

    })
  }

/**
 * getPreAuthUserData() - calling auth config  api and holding in service level
 * @author Amarjeet
 */
  getPreAuthUserData() {
   
    this.apiService.getPreAuthUserData(this.rootScope.activeCustTab.clientId, this.rootScope.activeCustTab.customerSessionId).subscribe({
      next: (data: any) => {
        /* istanbul ignore next */
        if (data?.httpStatusCode == 200 && data?.data) {
           this.rootScope.accountSAuthConfig = new sAuthModel();
          this.logger.debugLogs("getPreAuthUserData API successfully called response:" + JSON.stringify(data?.data), this.fileName);
          Object.keys(data?.data).forEach(x => {
            if (x === Constants.ALIS_USER_ID && data?.data?.[x]) {
              this.rootScope.accountSAuthConfig[x] = this.authService.encryptUserId(data?.data?.[x]);

            }
            else
              this.rootScope.accountSAuthConfig[x] = data?.data[x];
          });
          //this.authConfigUserData = data?.data;
          this.rootScope.accountSAuthConfig.preAuthUserAPIFail = false;
          this.rootScope.accountSAuthConfig.SAuthStatus = true;
          this.rootScope.authConfigUserDataMap[this.rootScope.activeCustTab.customerSessionId] = this.rootScope.accountSAuthConfig
          this.remainingAttempt = +this.rootScope.accountSAuthConfig.remainingPswdAttempt;
         //CCR3-11614
          if(this.rootScope.activeCustTab?.isNoPINClient){
            this.cusAccService.noPinSAuthModelValidation();
            if(this.authService.FTUPanelData?.Validation&&this.rootScope.activeCustTab.CS_SECURITY_LEVEL==Constants.securityLevels.SL2){
             this.rootScope.accountSAuthConfig.OTC = true;
            }
          }
          else{
            this.cusAccService.SAuthEnableValidation();
          }
        }
        else {
           this.rootScope.accountSAuthConfig = new sAuthModel();
          this.logger.debugLogs("getPreAuthUserData API getting invalid response :" + JSON.stringify(data?.data), this.fileName);
          this.rootScope.accountSAuthConfig.SAuthStatus = true;
          this.rootScope.accountSAuthConfig.preAuthUserAPIFail = true;
          this.rootScope.authConfigUserDataMap[this.rootScope.activeCustTab.customerSessionId] = this.rootScope.accountSAuthConfig;

        }
      },
      error: (error) => {
        if(error){   
         this.rootScope.accountSAuthConfig = new sAuthModel();
        this.rootScope.authConfigUserDataMap[this.rootScope.activeCustTab.customerSessionId] = error;
        this.rootScope.accountSAuthConfig.preAuthUserAPIFail = true;
        this.rootScope.authConfigUserDataMap[this.rootScope.activeCustTab.customerSessionId].preAuthUserAPIFail = true;
        this.logger.errorLogs(JSON.stringify(error), this.fileName);
        }
      },

    })
  }

  

  /**
  * Fetches the available languages from the backend service.
  * The API response is processed to extract language options.
  * Sets the default selected language if available.
  * @param mulLanData - array of object which contains the required language details.
  * @author Hashid
  */
  getLanguages(mulLanData): void {
    try {
      if (mulLanData) {
        const multiLangObj = mulLanData.find(item => item?.propertyName === 'MULTI-LANG');
        if (multiLangObj) {
          const parsedLanguages = JSON?.parse(multiLangObj?.propertyValue);
          this.languages = Object.keys(parsedLanguages).map(key => ({
            label: key,
            code: parsedLanguages[key]
          })).sort((a, b) => a.label.localeCompare(b.label));
          if (this.languages?.length > 0) {
            this.rootScope.activeCustTab.selectedAlisLang = this.languages[0]?.code;
            this.selectedLanguage = this.rootScope.activeCustTab?.selectedAlisLang;
          }
        }
      }
      this.logger.infoLogs('getLanguages successfully called for clientId:' + this.rootScope.activeCustTab.clientId, this.fileName);
    } catch (error) {
      this.logger.errorLogs('Error in getLanguages: ' +  JSON.stringify(error), this.fileName);
    }
  }

  /**
* Updates the selected language based on the radio button selection.
* This method is triggered whenever the selected radio button changes.
* @param selectedCode - The code of the language selected via the radio button.
* @author Hashid
*/
  onRadioChange(selectedCode): void {
    if (selectedCode) {
      this.rootScope.activeCustTab.selectedAlisLang = selectedCode;
    }
    else {
      this.rootScope.activeCustTab.selectedAlisLang = this.selectedLanguage
    }
  }

  /**
 * pinEntryAttrUpdate() - Updating genesys attribute for PIN Entry app process
 * @author Amarjeet
 * https://alightdevelopmentandit.atlassian.net/browse/CCR3-9252 ---CS_PIN_TEST_CFG,CS_PIN_UDP_TEST_CFG added by Vamsi krishna 
 */
  pinEntryAttrUpdate() {
   
    this.rootScope.activeCustTab.pinEntryApp.success=null;
    let authCode = Constants.AuthCode['PIN'];
    let body = this.authService.generateAttributeBody(authCode)
    this.logger.infoLogs("request body of pinEntryAttrUpdate API payload:" + JSON.stringify(body), this.fileName);
    this.rootScope.activeCustTab.pinChangeApp.pinChangePrcActive = false;
    this.genesysCloudService
      .updateParticipantAttributes(this.rootScope.activeCustTab.conversationId, this.rootScope.activeCustTab.customerParticipantId,body)
      .subscribe({
        next: (res) => {
          /* istanbul ignore next */
          if(res){
            this.logger.debugLogs("pinEntryAttrUpdate in Step1 successfully called for customerSessionId:" + this.rootScope.activeCustTab.customerSessionId, this.fileName);
          this.rootScope.activeCustTab.pinEntryApp.step1Active = false;
          this.rootScope.activeCustTab.pinEntryApp.step1Complete = true;
          this.rootScope.activeCustTab.pinEntryApp.step2Active = true;
          //CCR3-6188 to track/log authmehtod events
          this.genesysCloudService.updateTelephonyEventData(this.rootScope.genesysCallObj,Constants.AuthCode.PIN,"step1Completed successfully");
          this.genesysCloudService.updateTelephonyEventData(this.rootScope.genesysCallObj,Constants.logEvent.SUCCESS,res?.["attributes"]);
          // CCR3-12172 PIN Entry Simulation Flow
          if(this.rootScope.simulationData?.isSimulationModeActive && this.rootScope.activeCustTab.pinEntryApp?.step2Active){
            this.authService.simulatePinEntryFlow(false);    
          //this.genesysCloudService.updateTelephonyEventData(this.rootScope.genesysCallObj,Constants.logEvent.SUCCESS,res?.["attributes"]);
          }
        }},
        error: (err) => {
          this.logger.errorLogs(JSON.stringify(err), this.fileName);
        },
      });
  }

  /**
 * cancelButton() - moving user to first step.
 * @author Amarjeet
 */
  cancelButton() {
    this.rootScope.activeCustTab.pinEntryApp.step1Active = true;
    this.rootScope.activeCustTab.pinEntryApp.step1Complete = false;
    this.rootScope.activeCustTab.pinEntryApp.step2Active = false;
    this.genesysCloudService.updateTelephonyEventData(this.rootScope.genesysCallObj, Constants.AuthCode.PIN, "step1 Canceled");//CCR3-6188

  }

  /**
 * getMsg() - returning message based on condition to show on PIN entry app accordion hover icon.
 * param1 - passing security code
 * @author Amarjeet
 */
  getMsg(securityCode) {

    this.peaDisabled = true;
    let isPEACrustomerType = this.authService.CustTypeConfigCheck(securityCode);


    switch (true) {
      case ((!this.rootScope.isLiveCall && !this.rootScope.isLiveChat) || this.rootScope.activeCustTab?.activeChat):
      return this.peaToolTipMsg = Constants.PEA_MESSAGES.AVAILABLE_DURING_LIVE_INTERACTION;

      case (!isPEACrustomerType):
      return this.peaToolTipMsg = Constants.PEA_MESSAGES.PIN_NOT_AVAILABLE_FOR_CALLER;

      case (this.rootScope?.activeCustTab?.CS_SECURITY_LEVEL == Constants.securityLevels.SL4):
      return this.peaToolTipMsg = Constants.PEA_MESSAGES.CALLER_SECURED_MESSAGE;

      case (this.rootScope.activeCustTab?.IS_AAAS_ENABLED):
      return this.aaaSservice.aaasPinEntryInfoMsg(this);

      case (this.identifymodel()?.personStatus == Constants.SAuthStatus.AF):
      return this.peaToolTipMsg = Constants.AUTH_AF;

      case (this.identifymodel()?.personStatus == Constants.AuthMenu.FTU):
      return this.peaToolTipMsg = Constants.AUTH_FTU;

      case (this.NOFcase()):
      return this.peaToolTipMsg = Constants.PEA_MESSAGES.NOF;

      case (this.identifymodel()?.remainingPswdAttempt == 0):
      return this.peaToolTipMsg = Constants.PEA_MESSAGES.EXHAUSTED_ATTEMPTS;

      case (!this.identifymodel()?.voicePinOnFile && this.identifymodel()?.voicePinOnFile !== ''):
      return this.peaToolTipMsg = Constants.PEA_MESSAGES.NO_PIN_ON_FILE;
      // CCR3-12211 PIN Reset changes
      /*case (this.identifymodel()?.voicePinStatus?.toLowerCase() == 'expired' && this.identifymodel()?.voicePinResetDate == '' && this.identifymodel()?.voicePinOnFile==false):
      return this.peaToolTipMsg = Constants.PEA_MESSAGES.PIN_EXPIRED;*/

      case (this.identifymodel()?.voicePinStatus == 'LOCKED'):
      return this.peaToolTipMsg = Constants.PEA_MESSAGES.EXHAUSTED_ATTEMPTS;

      default:
      this.peaDisabled = false;
      return this.peaToolTipMsg = '';
    }
  }


 /**
 * pinChangeAttrUpdate() - Updating genesys attribute for PIN change app process
 * @author Hashid
 */
  /**
   * Updates the participant attributes for a PIN change process and manages the state of the PIN change application.
   * 
   * This method constructs a request body with various attributes related to the PIN change process and sends it to the 
   * `updateParticipantAttributes` method of the `genesysCloudService`. It also updates the state of the PIN change 
   * application based on the response received.
   * 
   * @remarks
   * - The method logs the constructed request body to the console.
   * - It sets the `pinChangePrcActive` flag to `true` to indicate that the PIN change process is active.
   * - On successful response, it updates the state of the PIN change application to reflect the completion of step 1 
   *   and the activation of step 2.
   * - It logs the success event and step completion to the telephony event data.
   * - On error, it logs the error to the console.
   * https://alightdevelopmentandit.atlassian.net/browse/CCR3-9252 ---CS_PIN_TEST_CFG,CS_PIN_UDP_TEST_CFG added by @VamsiKrishna
   * @returns void
   */
  pinChangeAttrUpdate() {
    let authCode = Constants.AuthCode['PINCNG'];
    let body = this.authService.generateAttributeBody(authCode);
    this.logger.infoLogs("request body of pinChangeAttrUpdate API payload:" + JSON.stringify(body), this.fileName);
    this.rootScope.activeCustTab.pinChangeApp.pinChangePrcActive = true;
    this.genesysCloudService
      .updateParticipantAttributes(this.rootScope.activeCustTab.conversationId, this.rootScope.activeCustTab.customerParticipantId, body)
      .subscribe({        
        next: (res) => {   

           /* istanbul ignore next */   
           if(res){    
            this.logger.infoLogs("pinChangeAttrUpdate in Step1 successfully called for customerSessionId:" + this.rootScope.activeCustTab.customerSessionId, this.fileName);       
          this.rootScope.activeCustTab.pinChangeApp.step1Active = false;
          this.rootScope.activeCustTab.pinChangeApp.step1Complete = true;
          this.rootScope.activeCustTab.pinChangeApp.step2Active = true;
          this.rootScope.activeCustTab.pinChangeApp.step2Complete = false;
          this.rootScope.activeCustTab.pinChangeApp.step3Complete = false;
          this.rootScope.activeCustTab.pinChangeApp.step3Active = false;
          this.rootScope.activeCustTab.pinChangeApp.step3Complete = false;
          this.rootScope.activeCustTab.pinChangeApp.pinChangeSucess = false;

          this.genesysCloudService.updateTelephonyEventData(this.rootScope.genesysCallObj, Constants.logEvent.SUCCESS, res?.["attributes"]);//CCR3-6188
          this.genesysCloudService.updateTelephonyEventData(this.rootScope.genesysCallObj, Constants.AuthCode.PINCNG, "step1Completed Successfully");//CCR3-6188
          // CCR3-12172 PIN Change Simulation Flow
          if(this.rootScope.simulationData?.isSimulationModeActive && this.rootScope.activeCustTab.pinChangeApp?.step2Active){
            this.authService.simulatePinChangeFlow();    
          //this.genesysCloudService.updateTelephonyEventData(this.rootScope.genesysCallObj,Constants.logEvent.SUCCESS,res?.["attributes"]);
          }
           }
        },
        error: (err) => {
          this.logger.errorLogs(JSON.stringify(err), this.fileName);
        },
      });
  }
  
   /**
 * cancelButton() - help user to cancell the pin change process and move to initial step.
 * @author Hashid
 */
   pinChangeCanlButton() {
    this.rootScope.activeCustTab.pinChangeApp.step1Active = true;
    this.rootScope.activeCustTab.pinChangeApp.step1Complete = false;
    this.rootScope.activeCustTab.pinChangeApp.step2Active = false;
    this.rootScope.activeCustTab.pinChangeApp.step2Complete = false;
    this.rootScope.activeCustTab.pinChangeApp.step3Complete = false;
    this.rootScope.activeCustTab.pinChangeApp.step3Active = false;
    this.rootScope.activeCustTab.pinChangeApp.step3Failed = false;
    this.rootScope.activeCustTab.pinChangeApp.step3Complete = false;
    this.rootScope.activeCustTab.pinChangeApp.pinChangeSucess = false;
    this.rootScope.activeCustTab.pinChangeApp.retryBtn = false;
    // CCR3-11548
    this.rootScope.activeCustTab.pinChangeApp.pinChngError = "";
    this.genesysCloudService.updateTelephonyEventData(this.rootScope.genesysCallObj, Constants.AuthCode.PINCNG, "step1 Canceled");//CCR3-6188

     
  }

 /**
 * getMethodName() - returning Authenticated method name.
 * @author Amarjeet
 */
 getMethodName(){
  let methodId=this.rootScope.activeCustTab?.genesysAttributes?.CS_AUTH_CD;
  return methodId && Constants.AuthMethods[methodId] ? '['+ Constants.AuthMethods[methodId ]+']':'';
}

 /* istanbul ignore next */
 openVALPopup() {
  this.rootScope.openDialog({
    title: 'Customer Reminder: Voluntary Account Lock Key',
    subheading: '',
    message: "It’s important that you remember your Voluntary Account Key. If it is forgotten, the recovery process is lengthy, and cannot be expedited.",
    firstbutton: '',
    secondbutton: 'Informed caller',
    crossIcon: false,
    comingFrom: 'authentication',
    additionalClass: 'start-voluntary-lock',
  });
  this.logger.infoLogs('openVALPopup successfully called for customerSessionId:' + this.rootScope.activeCustTab?.customerSessionId, this.fileName);

}
/**
 * 
 * @param Method 
 * which auth method status user need to check
 * @returns 
 */
  enableAuthLink(Method) {
    if (this.rootScope.activeCustTab.CS_SECURITY_LEVEL == Constants.securityLevels.SL4
      && this.rootScope.activeCustTab.channel == Constants.IH_CALL &&this.rootScope.isLiveCall
      && this.identifymodel()?.personStatus != Constants.SAuthStatus.AF&& this.authService.CustTypeConfigCheck(Method)&&
      (Method == Constants.AuthMenu.PINRESET || Method == Constants.AuthMenu.PINCNG)) {

      return (this.identifymodel()[Method]);
    }
    else if (this.infoWarning(Method)) return false;
    else {
      return (this.identifymodel()[Method]);
    }
  }
/**
 * 
 * @returns false/true based on SAuth and live interaction status
 */
  infoValidation(Code) {
    const activeTab = this.rootScope.activeCustTab;

    if ((Code == this.eGainConfig.PINRESET||Code == this.eGainConfig.PIN_REM_FSBA) && this.rootScope.isLiveCall
      && activeTab?.CS_SECURITY_LEVEL == Constants.securityLevels.SL4
      && this.identifymodel()?.personStatus != Constants.SAuthStatus.AF && this.authService.CustTypeConfigCheck(Code)) {
      return false;
    }
    else if (Code == this.eGainConfig.OTC && this.rootScope.isLiveCall
      && activeTab?.CS_SECURITY_LEVEL != Constants.securityLevels.SL4
      && this.identifymodel()?.personStatus == Constants.AuthMenu.FTU && this.authService.CustTypeConfigCheck(Code)) {
      if (this.authService.FTUPanelData?.Validation && activeTab?.isNoPINClient)
        return false;
      else return true;
    }
    else return this.infoWarning(Code);
  }


  /**
   * 
   * @returns If below method return true ,OTC panel will be look like disabled
   * If false - it will look like enabled.
   */
  getOTCMsgAndState() {

    if (this.rootScope.activeCustTab.activeCall) {
      if (this.clientConfigButCTNot) {
        this.OTCMsg = Constants.OTC_NOT_CONFIGURED_CUSTTYPE;
        this.disableOTCPanel = true;
        this.displayOTCMsg = true;
        return true;
      }

      if (this.rootScope.activeCustTab?.CS_SECURITY_LEVEL == Constants.securityLevels.SL4) {
        this.OTCMsg = Constants.OTC_FULL_SECURED_MSG;
        this.disableOTCPanel = true;
        this.displayOTCMsg = true;
        return true;
      }
      else {
        //if call is unsecured ,it  should enabled;
        this.displayOTCMsg = false
        return false;
      }
    }
    return false;
  }

  valState() {
    if (this.rootScope.activeCustTab.activeCall) {
      if (this.rootScope.activeCustTab?.CS_SECURITY_LEVEL == Constants.securityLevels.SL4) { /** Fully secured call */
        return true;
      }
      else {
        this.valMsg = Constants.VAL_UNSECUREDCALL_MSG; /**Unsecured call */
        return false;
      }
    }
    else if (this.rootScope.activeCustTab.activeChat) { /** chat mode */
      this.valMsg = Constants.VAL_CHATMODE_MSG;
      return false;
    }
    else {
      /** Research Mode  */
      this.valMsg = Constants.VAL_OFFMODE_MSG;
      return false;
    }
  }
/**
 * 
 * @returns returns the model based on whether AAAS is enabled or not
 * @author Vamsi Krishna
 */
  identifymodel(){
    if(this.rootScope.activeCustTab.IS_AAAS_ENABLED){
      return this.rootScope.accountAaaSConfig;  
    }
    else 
    return this.rootScope.accountSAuthConfig;
  }
/**
 * 
 * @returns true/false based on AAAS error message
 * @author Vamsi Krishna
 */
  aaasErrorMsg() {
    if (this.rootScope.activeCustTab?.IS_AAAS_ENABLED&&this.aaaSservice.AaaSFieldListData?.[this.rootScope.activeCustTab.clientId] && (this.rootScope.accountAaaSConfig?.AAASUserAPIFail||this.rootScope.accountAaaSConfig?.InternalServerError)) {
      return true;
    }
    else {
      return false;
    }
  }


   /**
    * Recomputes the cached DeSecure Call flag only when the relevant customer-tab
    * values change, avoiding repeated configuration parsing during change detection.
    */
   private updateDeSecureCallFeatureEnabledCache(): void {
     const activeCustTab = this.rootScope.activeCustTab;
     const clientId = activeCustTab?.clientId;
     const authCode = activeCustTab?.genesysAttributes?.CS_AUTH_CD;
     const securityLevel = activeCustTab?.CS_SECURITY_LEVEL;
     const activeCall = activeCustTab?.activeCall;
     const cacheUnchanged =
       this.deSecureCallFeatureCacheClientId === clientId &&
       this.deSecureCallFeatureCacheAuthCode === authCode &&
       this.deSecureCallFeatureCacheSecurityLevel === securityLevel &&
       this.deSecureCallFeatureCacheActiveCall === activeCall;
     if (cacheUnchanged) {
       return;
     }
     this.deSecureCallFeatureCacheClientId = clientId;
     this.deSecureCallFeatureCacheAuthCode = authCode;
     this.deSecureCallFeatureCacheSecurityLevel = securityLevel;
     this.deSecureCallFeatureCacheActiveCall = activeCall;
     this.deSecureCallFeatureEnabled =
       !!clientId &&
       this.rootScope.isDesecureCallFeatureConfigured(Constants.AuthMenu.IND_DATA, clientId) &&
       authCode == Constants.AuthMenu.IND_DATA &&
       securityLevel == Constants.securityLevels.SL4 &&
       !!activeCall;
       
   }

  /**
   * Checks whether the DeSecure Call feature should be enabled for the active customer tab.
   * Returns true only when the feature is configured for IND_DATA, the call is authenticated
   * via IND_DATA at security level 4, and there is an active live call.
   * @returns boolean indicating if the DeSecure Call button should be enabled
   */
  deSecureCallFeatureEnable(): boolean {
     this.updateDeSecureCallFeatureEnabledCache();
     return this.deSecureCallFeatureEnabled;
  }


  /**
   * Initiates the de-secure account flow. If any additional account is still open
   * for the active live call, prompts the user to close it first; otherwise,
   * shows the de-secure confirmation dialog.
   */
  desecureAccount(){
    if(this.checkAdditionalAccountOpenedForLiveCall()){
      this.closeAllAccount();
    } else {
      this.confirmDesecureAccount();
      this.closeAllPanels();
    }
  }

  /**
   * Checks whether any additional account tab is currently open for the active live call's parent tab.
   * Finds the live call account and verifies if any other tab's id matches its additionalAccountId
   * on the same conversation.
   * @returns true if an additional account is open for the live call, false otherwise
   */
  checkAdditionalAccountOpenedForLiveCall(): boolean {
    const liveCallAccount = this.rootScope.customerTabs?.find(x => x?.activeCall === true);
    const additionalAccountId = liveCallAccount?.additionalAccountId;

    if (additionalAccountId == null || String(additionalAccountId) == '') {
      return false;
    }

    const normalizedAdditionalAccountId = String(additionalAccountId);

    return this.rootScope.customerTabs?.some((x) =>
      String(x?.id) === normalizedAdditionalAccountId &&
      x?.conversationId === liveCallAccount?.conversationId
    );
  }

  

  /**
   * Displays a dialog informing the user to close all open additional accounts
   * before the call can be de-secured.
   */
  closeAllAccount() {
    this.rootScope.openDialog({
      title: 'Close Additional Accounts',
      subheading: '',
      message: "You must close all open Additional Accounts before changing this call to unsecured.",
      firstbutton: '',
      secondbutton: 'Got it',
      crossIcon: false,
      comingFrom: 'authentication',
      additionalClass: 'closeAllAccount',
    });
  }


  /**
   * Displays a confirmation dialog asking the user to confirm de-securing the call.
   */
  confirmDesecureAccount() {
    this.rootScope.openDialog({
      title: 'Change Call to Unsecured',
      subheading: '',
      message: "Are you sure you want to make this call unsecured? You can re-secure it at any time.",
      firstbutton: 'No',
      secondbutton: 'Yes',
      crossIcon: false,
      comingFrom: 'authentication',
      additionalClass: 'desecurecall',
    });
  }

  /**
   * Determines whether the current call has been de-secured from indicative data authentication.
   *
   * Returns true only when all of the following conditions are met:
   * - The Genesys unsecure security level update for indicative data has been applied.
   * - There is an active live call on the current customer tab.
   * - The security level has been downgraded to SL2.
   *
   * @returns boolean indicating if the call was de-secured via indicative data
   */
  isCallDeSecuredFromIndicativeData(): boolean {
    return (
      this.rootScope.activeCustTab.isGenesysUnsecureSecurityLevelUpdatedForIndicativeData &&
      this.rootScope.activeCustTab.activeCall &&
      this.rootScope.activeCustTab.CS_SECURITY_LEVEL === Constants.securityLevels.SL2
    );
  }



 

  /**
   * Closes all expanded authentication method expansion panels and resets
   * the Last 4 SSN, DOB, and checkbox fields in the indicative data form.
   */
  closeAllPanels(): void {
    this.rootScope.activeCustTab.authenticationEgainContent.authenticationType = '';
    this.resetIndicativeDataSelectedFields();
    if (this.accordion) {
      this.accordion.closeAll();
    }
  }

  /**
   * Resets all indicative data form fields except FULLNAME and POSTALADDRESS.
   * Also resets the name and address verification checkboxes.
   */
  resetIndicativeDataSelectedFields(): void {
    const form = this.cusAccService.indicativeDataForm;
    if (!form) {
      return;
    }
    const keyTitleMapping = this.rootScope.activeCustTab?.authenticationIndicativeData?.keyTitleMapping;
    if (keyTitleMapping) {
      keyTitleMapping.forEach((mapping: { key: string; title: string }) => {
        if (mapping.title !== 'FULLNAME' && mapping.title !== this.postalAddress) {
          const control = form.get(mapping.key);
          if (control) {
            control.reset();
            control.markAsUntouched();
            control.markAsPristine();
          }
        }
      });

      const checkboxControl = form.get('additionalCheckboxKey');
      if (checkboxControl) {
        checkboxControl.reset();
        checkboxControl.markAsUntouched();
        checkboxControl.markAsPristine();
      }
      const addressCheckboxControl = form.get('additionalAddressCheckboxKey');
      if (addressCheckboxControl) {
        addressCheckboxControl.reset();
        addressCheckboxControl.markAsUntouched();
        addressCheckboxControl.markAsPristine();
      }
    }
  }

  
}